import ApiService from '@/services/api.service';

class CommonService {
    async addCreditCard(cardData: any) {
        return ApiService.post('/v2/payment/save-card', cardData)
    }

    async cardPayment(paymentData: any) {
        return ApiService.post('/v2/payment/card-payment', paymentData)
    }
}

export default new CommonService();